import { AsyncPipe, isPlatformBrowser, NgClass } from '@angular/common';
import { Component, DOCUMENT, EventEmitter, inject, Input, OnDestroy, Output, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

import { Layout } from '../../../api/v1/models/layout';
import { ModalSwipeDirective } from '../../directives/modal-swipe/modal-swipe.directive';
import { OverlaySwipeDirective } from '../../directives/modal-swipe/overlay-swipe.directive';
import { BottomSwipeSheetDirective } from '../../directives/modal-swipe/bottom-swipe-sheet.directive';
import { ConfigRepository } from '../../repositories/config.repository';
import { BreakpointService } from '../../services/breakpoint.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  imports: [
    ModalSwipeDirective,
    OverlaySwipeDirective,
    BottomSwipeSheetDirective,
    MatIconModule,
    NgClass,
    AsyncPipe,
  ]
})
export class ModalComponent implements OnDestroy {
  breakPoint = inject(BreakpointService);
  private renderer = inject(Renderer2);
  private config = inject(ConfigRepository);
  private platformId = inject(PLATFORM_ID);
  private document = inject<Document>(DOCUMENT);

  @ViewChild(ModalSwipeDirective) modalSwipe: ModalSwipeDirective;

  @Input() isDialog: boolean = false;
  @Input() isSmall: boolean = true;
  @Input() title?: string = '';
  @Input() additionalClass?: string;
  @Input() swipeDirection?: string = '';
  @Input() isHideHead: boolean = false;

  @Output() closeModal = new EventEmitter();

  layout$: Observable<Layout> = this.config.layout$;

  layouts = Layout;

  onClose(): void {
    if(isPlatformBrowser(this.platformId)) {
      this.renderer.removeClass(this.document.documentElement, 'is-scroll');
    }

    if(this.swipeDirection === 'bottom') {
      this.modalSwipe.hideModal('down');
    }
    else {
      this.modalSwipe.hideModal('right');
    }
    this.closeModal.emit();
  }

  ngOnDestroy(): void {
    if(!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.renderer.removeClass(this.document.documentElement, 'is-scroll');
  }
}
